import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { getUrlPrefix } from 'src/utils/getUrl';

import { routes } from './routes';

export const RouteProvider = () => {
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
  const router = sentryCreateBrowserRouter(routes, {
    basename: getUrlPrefix(),
  });

  return <ReactRouterProvider router={router} />;
};
